export const baseUrl='https://api.themoviedb.org/3';
export const API_KEY ="5933d9c8bb3356a05d760990abfa9654";
export const imageUrl = 'https://image.tmdb.org/t/p/original';